export const heroInfo = {
  title: "HIPAA Compliance & Blockchain Audit Ledger",
  badge: "Needs Attention",
  subtitle: "Industrial Automation Security Assessment • Last Updated: Dec 18, 2024 09:45 AM",
  score: 78,
};

export const aiStrategy =
  "To reach 100% HIPAA compliance, you must encrypt the data transmission for the 12 SCADA assets currently operating on Modbus (Plaintext). Additionally, 4 access control logs are missing digital signatures.";

export const scorecard = [
  { id: "164.308(a)(1)", name: "Risk Management", status: "Failed", evidence: "Missing" },
  { id: "164.312(a)(1)", name: "Access Control", status: "Pass", evidence: "Verified (Hash: 0x4B...)" },
  { id: "164.312(e)(1)", name: "Transmission Security", status: "Failed", evidence: "Encryption Disabled" },
  { id: "164.308(c)(1)", name: "Data Integrity", status: "Pass", evidence: "Blockchain Anchored" },
  { id: "164.314(a)(1)", name: "Business Associate", status: "WARNING", evidence: "Pending Review" },
];

export const auditLedger = [
  { event: "#847293", date: "2024-12-18", time: "10:12:01", action: "Policy Modification", actor: "Admin_01", hash: "0x7f2b91...8c4", nodes: "4/4", status: "Verified" },
  { event: "#847294", date: "2024-12-18", time: "10:14:55", action: "Asset Isolation", actor: "System_AI", hash: "0x9a4c11...2d1", nodes: "4/4", status: "Verified" },
  { event: "#847295", date: "2024-12-18", time: "10:20:10", action: "User Login (MFA)", actor: "Lead_Eng_JD", hash: "0x3e8d22...9f0", nodes: "3/4", status: "Syncing" },
  { event: "#847296", date: "2024-12-17", time: "10:22:30", action: "Failed Login Attempt", actor: "Unknown_Ext", hash: "0x1b2a44...6e2", nodes: "4/4", status: "Verified" },
  { event: "#847297", date: "2024-12-17", time: "10:25:00", action: "Firmware Update", actor: "Tech_Support", hash: "0x8c7e33...1a4", nodes: "4/4", status: "Verified" },
  { event: "#847298", date: "2024-12-17", time: "10:30:12", action: "Modbus Traffic Stop", actor: "Firewall_Z1", hash: "0x5d9b55...3b8", nodes: "4/4", status: "Verified" },
];
